import { StateCreator } from "zustand";
import { WidgetStore, ErrorState, ErrorActions } from "../types";

const initialErrorState: ErrorState = {
  error: null,
  errorTimestamp: null,
};

export const createErrorSlice: StateCreator<
  WidgetStore,
  [],
  [],
  ErrorState & ErrorActions
> = (set) => ({
  ...initialErrorState,

  setError: (error) =>
    set({
      error,
      errorTimestamp: error ? Date.now() : null,
    }),

  clearError: () => set(initialErrorState),
});
